import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Nav, INavLink, INavStyles, INavLinkGroup } from 'office-ui-fabric-react/lib/Nav';
import { RootState } from "~/store/ducks"
import { DataTypes } from "~/store/ducks/home/types"
import { Creators } from "~/store/ducks/home"
import { withRouter, useHistory } from "react-router-dom";

const iconStyles = {
  root:
  {
    color: '#323130',
    marginLeft: 10,
    marginRight: 11,
  }
}

const NavBar: React.FC = () => {
  const pageState = useSelector<RootState, DataTypes>(state => state.homeReducer)
  const [currentKeyPage, setCurrentKeyPage] = useState<string>("");
  const [isCadastroMenuOpen, setIsCadastroMenuOpen] = useState<boolean>(true);
  const [isDesempenhoMenuOpen, setIsDesempenhoMenuOpen] = useState<boolean>(true);
  const [isAvaliacaoMenuOpen, setIsAvaliacaoMenuOpen] = useState<boolean>(true);
  // const [hasHoverCadastros, setHasHoverCadastros] = useState<boolean>(false);
  const dispatch = useDispatch();
  const history = useHistory();

  useEffect(() => {
    if (pageState.isMenuExpanded) {
      setCurrentKeyPage(pageState.page.key);
    } else {
      const statePage = pageState.page.key;

      if (statePage === 'home') {
        setCurrentKeyPage("home");
      } else if (statePage === "perfil") {
        setCurrentKeyPage(pageState.page.key);
      } else if (statePage === 'atitudes' || statePage === 'pilares' || statePage === 'objetivos' || statePage === 'ciclos' || statePage === "workflow") {
        setCurrentKeyPage("desempenho");
      } else if (statePage === 'empresas' || statePage === 'unidades' || statePage === 'organograma' || statePage === 'cargos' || statePage === 'funcionarios'){
        setCurrentKeyPage("cadastros");
      }else{
        setCurrentKeyPage("avaliacoesMenu")
      };
    };
  }, [pageState])

  // useEffect(() => {
  //   if (!pageState.isMenuExpanded) {
  //     const elParent = document.querySelector(`[aria-current="page"]`)?.parentNode?.parentNode?.parentNode?.parentNode?.firstChild;
  //     const parentKey = (elParent as HTMLElement)?.getAttribute("name")?.toLocaleLowerCase()!;
  //     if (parentKey !== undefined) {
  //       setCurrentKeyPage(parentKey);
  //     } else {
  //       setCurrentKeyPage(pageState.page.key);
  //     };
  //   } else {
  //     setCurrentKeyPage(pageState.page.key);
  //   };
  // }, [pageState]);

  // useEffect(() => {
  //   if (!pageState.isMenuExpanded) {
  //     const btnCadastro = document.querySelector('div[name="Cadastros"]')?.parentNode;
  //     btnCadastro?.addEventListener("mouseover", () => {
  //       setHasHoverCadastros(true);
  //     });
  //     // btnCadastro?.addEventListener("mouseout", () => {
  //     //   setHasHoverCadastros(false);
  //     // });
  //   }
  // }, [pageState.isMenuExpanded])

  // React.useEffect(() => {
  //   const iconPillar = document.querySelector("[data-icon-name=pillar]");
  //   iconPillar!.innerHTML = `
  //   <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 62 62" class="icon-nav">
  //   <path id="pillar" d="M59,14.083,59.847,9H61a2,2,0,0,0,2-2V3a2,2,0,0,0-2-2H3A2,2,0,0,0,1,3V7A2,2,0,0,0,3,9H4.153L5,14.083V55a2,2,0,0,0-2,2v4H1v2H63V61H61V57a2,2,0,0,0-2-2ZM51,55V19h2V55Zm-8,2v4H41V57a2,2,0,0,0-2-2V14.083L39.847,9h4.306L45,14.083V55A2,2,0,0,0,43,57ZM7,16a1,1,0,1,1,1,1A1,1,0,0,1,7,16Zm10,0a1,1,0,1,1-1-1A1,1,0,0,1,17,16Zm-4,0a1,1,0,1,1-1-1A1,1,0,0,1,13,16Zm0,3V55H11V19Zm2,0h2.012L17,55H15Zm4,36V14.083L19.847,9h4.306L25,14.083V55a2,2,0,0,0-2,2v4H21V57A2,2,0,0,0,19,55Zm16,0V19h2.012L37,55Zm2-39a1,1,0,1,1-1-1A1,1,0,0,1,37,16Zm-4,0a1,1,0,1,1-1-1A1,1,0,0,1,33,16Zm-4,0a1,1,0,1,1-1-1A1,1,0,0,1,29,16Zm-2,3h2V55H27Zm4,0h2V55H31Zm6.153-6H26.836l-.658-4H37.82ZM25,57H39v4H25ZM53,16a1,1,0,1,1-1-1A1,1,0,0,1,53,16Zm-4,0a1,1,0,1,1-1-1A1,1,0,0,1,49,16Zm-2,3h2V55H47Zm8-3a1,1,0,1,1,1,1A1,1,0,0,1,55,16Zm2.153-3H46.836l-.658-4H57.82ZM3,3H61V7H3ZM17.82,9l-.667,4H6.836L6.178,9ZM7,19H9V55H7ZM5,57H19v4H5Zm40,4V57H59v4Zm10-6V19h2.012L57,55Z" transform="translate(-1 -1)"/>
  //   </svg>
  //   `;
  //   const iconSupermarket = document.querySelector("[data-icon-name=supermarket]");
  //   iconSupermarket!.innerHTML = `
  //   <svg class="icon-nav" id="Layer_3" enable-background="new 0 0 64 64" height="16" viewBox="0 0 64 64" width="16" xmlns="http://www.w3.org/2000/svg"><g><path d="m60 7h-2v-1c0-1.654-1.346-3-3-3h-11c0-1.103-.897-2-2-2h-20c-1.103 0-2 .897-2 2h-11c-1.654 0-3 1.346-3 3v1h-2c-1.654 0-3 1.346-3 3v6 5c0 1.859 1.28 3.411 3 3.858v30.142c-1.654 0-3 1.346-3 3v4c0 .553.448 1 1 1h60c.552 0 1-.447 1-1v-4c0-1.654-1.346-3-3-3v-30.142c1.72-.447 3-1.999 3-3.858v-5-6c0-1.654-1.346-3-3-3zm-5-2c.551 0 1 .448 1 1v1h-12v-2zm-33-2h20l.001 8h-20.001zm-14 3c0-.552.449-1 1-1h11v2h-12zm-4 3h16v2c0 1.103.897 2 2 2h20c1.103 0 2-.897 2-2v-2h16c.551 0 1 .448 1 1v5h-5-6-6-6-6-6-6-6-6-5v-5c0-.552.449-1 1-1zm47 8h4v4c0 1.103-.897 2-2 2s-2-.897-2-2zm-6 0h4v4c0 1.103-.897 2-2 2s-2-.897-2-2zm-6 0h4v4c0 1.103-.897 2-2 2s-2-.897-2-2zm-6 0h4v4c0 1.103-.897 2-2 2s-2-.897-2-2zm-6 0h4v4c0 1.103-.897 2-2 2s-2-.897-2-2zm-6 0h4v4c0 1.103-.897 2-2 2s-2-.897-2-2zm-6 0h4v4c0 1.103-.897 2-2 2s-2-.897-2-2zm-6 0h4v4c0 1.103-.897 2-2 2s-2-.897-2-2zm-6 4v-4h4v4c0 1.103-.897 2-2 2s-2-.897-2-2zm3 12h28v14h-28zm28-2h-28v-2h28zm-28 18h28v6h-28zm55 9v3h-58v-3c0-.552.449-1 1-1h56c.551 0 1 .448 1 1zm-7-27h-14v-2h14zm-14 2h14v22h-14zm16 22v-27c0-.553-.448-1-1-1h-16c-.552 0-1 .447-1 1v27h-2v-27c0-.553-.448-1-1-1h-29v-2.142c.79-.205 1.479-.643 2-1.24.734.84 1.8 1.382 3 1.382s2.266-.542 3-1.382c.734.84 1.8 1.382 3 1.382s2.266-.542 3-1.382c.734.84 1.8 1.382 3 1.382s2.266-.542 3-1.382c.734.84 1.8 1.382 3 1.382s2.266-.542 3-1.382c.734.84 1.8 1.382 3 1.382s2.266-.542 3-1.382c.734.84 1.8 1.382 3 1.382s2.266-.542 3-1.382c.734.84 1.8 1.382 3 1.382s2.266-.542 3-1.382c.734.84 1.8 1.382 3 1.382s2.266-.542 3-1.382c.521.597 1.21 1.035 2 1.24v30.142zm5-34c0 1.103-.897 2-2 2s-2-.897-2-2v-4h4z"/><path d="m8.55 39.5h9.899v2h-9.899z" transform="matrix(.707 -.707 .707 .707 -24.684 21.408)"/><path d="m17.55 39.5h9.899v2h-9.899z" transform="matrix(.707 -.707 .707 .707 -22.048 27.772)"/><path d="m37 4h-10c-1.654 0-3 1.346-3 3s1.346 3 3 3h10c1.654 0 3-1.346 3-3s-1.346-3-3-3zm0 4h-10c-.551 0-1-.448-1-1s.449-1 1-1h10c.551 0 1 .448 1 1s-.449 1-1 1z"/><circle cx="43" cy="42" r="2"/></g></svg>
  //   `

  // }, [])

  const navLinkGroups: INavLinkGroup[] = [
    {
      links: [
        // {
        //   name: '',
        //   url: '',
        //   key: 'menu',
        //   iconProps: { iconName: 'GlobalNavButton', styles: iconStyles }
        // },
        {
          name: 'Página Inicial',
          url: "",
          key: 'home',
          iconProps: { iconName: 'Home', styles: iconStyles },
        },
        {
          name: 'Perfil',
          url: '',
          key: 'perfil',
          iconProps: { iconName: 'Contact', styles: iconStyles },
        },
        // {
        //   name: 'Auto Avaliação',
        //   url: '',
        //   key: 'autoavaliacao',
        //   iconProps: { iconName: 'Contact', styles: iconStyles },
        // },
        // {
        //   name: 'Time Avaliação',
        //   url: '',
        //   key: 'timeavaliacao',
        //   iconProps: { iconName: 'Contact', styles: iconStyles },
        // },
        {
          name: 'Cadastros',
          url: '',
          key: 'cadastros',
          iconProps: { iconName: 'Edit', styles: iconStyles },
          expandAriaLabel: 'Expandir seção de cadastros',
          collapseAriaLabel: 'Recolher seção de cadastros',
          links: [
            {
              name: 'Empresas',
              url: '',
              key: 'empresas',
            },
            {
              name: 'Unidades',
              url: '',
              key: 'unidades',
            },
            {
              name: 'Organograma',
              url: '',
              key: 'organograma',
            },
            {
              name: 'Cargos',
              url: '',
              key: 'cargos',
            },
            {
              name: 'Funcionários',
              url: '',
              key: 'funcionarios',
            }
          ],
          isExpanded: isCadastroMenuOpen,
        },
        {
          name: 'Desempenho',
          url: '',
          key: 'desempenho',
          iconProps: { iconName: 'BIDashboard', styles: iconStyles },
          expandAriaLabel: 'Expandir seção de desempenho',
          collapseAriaLabel: 'Recolher seção de desempenho',
          isExpanded: isDesempenhoMenuOpen,
          links: [
            {
              name: 'Atitudes',
              url: '',
              key: 'atitudes',
            },
            {
              name: 'Pilares',
              url: '',
              key: 'pilares',
            },
            {
              name: 'Objetivos',
              url: '',
              key: 'objetivos',
            },
            {
              name: 'Ciclos',
              url: '',
              key: 'ciclos',
            },
            {
              name: 'Painel WorkFlow',
              url: '',
              key: 'workflow',
            },
            // {
            //   name: 'Avaliações',
            //   url: '',
            //   key: 'avaliacoes',
            // },
          ]
        },
        {
          name: 'Avaliações',
          url: '',
          key: 'avaliacoesMenu',
          iconProps: { iconName: 'Trackers', styles: iconStyles },
          expandAriaLabel: 'Expandir seção de avaliações',
          collapseAriaLabel: 'Recolher seção de avaliações',
          links: [
            {
              name: 'Auto Avaliação',
              url: '',
              key: 'autoavaliacao',
            },
            {
              name: 'Time Avaliação',
              url: '',
              key: 'timeavaliacao',
            },
            {
              name: 'Avaliações',
              url: '',
              key: 'avaliacoes',
            },
          ],
          isExpanded: isAvaliacaoMenuOpen,
        },

        // {
        //   name: 'Pilares',
        //   url: '',
        //   iconProps: { iconName: 'pillar', styles: iconStyles },
        //   key: 'pilares',
        // },

        // {
        //   name: 'Empresas',
        //   url: '',
        //   iconProps: { iconName: 'supermarket', styles: iconStyles },
        //   key: 'empresas',
        // },
      ],
    },
  ];

  const navStyles: Partial<INavStyles> = {
    root: {
      width: pageState.isMenuExpanded ? "250px" : '48px',
      transition: 'width 0.3s',
      height: "calc(100vh - 50px)",
      backgroundColor: "#CFD3DA",
      boxSizing: 'border-box',
      overflowX: 'hidden',
      overflowY: 'auto',
      selectors: {
        '[aria-current=page]': {
          backgroundColor: '#F5F6F7',
        },
        'li ul[role=list]': {
          backgroundColor: "#EBEDF0",
          display: pageState.isMenuExpanded ? 'block' : 'none',
          selectors: {
            'li div button': {
              height: 32
            },
            '&hover ': {
              height: 32
            }
          }
        },
      }
    },
    chevronIcon: {
      marginLeft: 8,
      marginRight: 11
    },
    chevronButton: {
      width: 40,
      left: 210,
      selectors: {
        '&:after': {
          border: 'none'
        }
      }
    },
    //link: {
    // selectors: {
    //   "&[title=Cadastros], &[title=Desempenho]": {
    //     paddingLeft: 40,
    //   }
    // }
    //},
  };

  const navStyles2: Partial<INavStyles> = {
    root: {
      position: 'absolute',
      top: 182,
      left: 48,
      width: 250,
      backgroundColor: "#CFD3DA"
    },

  };


  function _onLinkClick(ev?: React.MouseEvent<HTMLElement>, item?: INavLink) {
    if (item) {
      switch (item.key) {
        // case 'menu':
        //   setIsMenuExpanded(!isMenuExpanded);
        //   break;
        case 'home':
          history.push("/");
          break;
        case 'perfil':
          history.push("/perfil");
          break;
        case 'cadastros':
          if (pageState.isMenuExpanded) {
            setIsCadastroMenuOpen(!isCadastroMenuOpen);
          } else {
            setIsCadastroMenuOpen(true);
          }
          dispatch(Creators.setMenuExpanded(true));
          break;
        case 'desempenho':
          if (pageState.isMenuExpanded) {
            setIsDesempenhoMenuOpen(!isDesempenhoMenuOpen);
          } else {
            setIsDesempenhoMenuOpen(true);
          }
          dispatch(Creators.setMenuExpanded(true));
          break;
        case 'avaliacoesMenu':
          if (pageState.isMenuExpanded) {
            setIsAvaliacaoMenuOpen(!isAvaliacaoMenuOpen);
          } else {
            setIsAvaliacaoMenuOpen(true);
          }
          dispatch(Creators.setMenuExpanded(true));
          break;
        case 'atitudes':
          history.push("/atitudes");
          break;
        case 'pilares':
          history.push("/pilares");
          break;
        case 'objetivos':
          history.push("/objetivos");
          break;
        case 'ciclos':
          history.push("/ciclos");
          break;
        case 'avaliacoes':
          history.push("/avaliacoes");
          break;
        case 'workflow':
          history.push("/workflow");
          break;
        case 'empresas':
          history.push("/empresas");
          break;
        case 'organograma':
          history.push("/organograma");
          break;
        case 'funcionarios':
          history.push("/funcionarios");
          break;
        case 'unidades':
          history.push("/unidades");
          break;
        case 'cargos':
          history.push("/cargos");
          break;
        case 'autoavaliacao':
          history.push("/workflow/autoavaliacao");
          break;
        case 'timeavaliacao':
          history.push("/workflow/timeavaliacao");
          break;
      }
    }
  }

  return (
    <div style={{ zIndex: 10 }}>
      <Nav
        onLinkClick={_onLinkClick}
        selectedKey={pageState.isMenuExpanded ? pageState.page.key : currentKeyPage}
        ariaLabel="Menu"
        styles={navStyles}
        groups={navLinkGroups}
      // linkAs={(props) => {
      //   return <Link className={props.className} style={{ color: 'inherit', boxSizing: 'border-box' }} to={"/"}>
      //     <span style={{ display: 'flex' }}>
      //       {!!props.iconProps && <FontIcon style={{ margin: '0 4px' }} {...props.iconProps} />}

      //       {props.children}
      //     </span>
      //   </Link>;
      // }}
      />
      {/* {
        !isMenuExpanded && hasHoverCadastros &&
        <Nav
          onLinkClick={_onLinkClick}
          selectedKey={pageState.page.key}
          ariaLabel="Menu"
          styles={navStyles2}
          groups={navLinkGroups2}
        />
      } */}
    </div>
  )
};

export default withRouter(NavBar)
